import { render, staticRenderFns } from "./BuyerView.vue?vue&type=template&id=2ceaa350&"
import script from "./BuyerView.vue?vue&type=script&lang=js&"
export * from "./BuyerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports